import { HTTP } from "@cerbos/http";

export const cerbos = new HTTP(process.env.VITE_ACCESS_URL);